import React, { FC } from 'react';

import NewSeason from './NewSeason/NewSeason';
import RegisteredSeasons from './RegisteredSeasons/RegisteredSeasons';
import { SeasonsSectionStyled } from './SeasonsSection.Styles';

const SeasonsSection: FC = () => {
  return (
    <SeasonsSectionStyled>
      <NewSeason />

      <RegisteredSeasons />
    </SeasonsSectionStyled>
  );
};

export default SeasonsSection;
